import React, { createContext } from 'react'

interface IProps {
  children: React.ReactNode
  gridId: string | number | undefined
  pageId?: number
}

export const GridBlockContext = createContext<{
  gridId: string | number | undefined
  pageId: string | number | undefined
}>({
  gridId: 0,
  pageId: 0,
})

export const GridBlockProvider = ({ children, gridId, pageId }: IProps) => {
  return (
    <GridBlockContext.Provider
      value={{ gridId: gridId, pageId: pageId }}
      children={children}
    />
  )
}
